import React, { useState } from "react"
import { Link } from "react-scroll"
import { useTranslation } from "gatsby-plugin-react-i18next"

const Toc = ({ headings, headerSizes, title }) => {
  const { t } = useTranslation()
  const [showToc, setShowToc] = useState(true)

  return (
    <ul
      className={`transition-all ease-in-out fixed lg:right-auto top-16 lg:top-auto pb-12 w-[300px] lg:w-auto border-l pt-8 b-slate-100 bg-white ml-3 ${
        showToc ? "right-0" : "-right-[300px]"
      }`}
    >
      <li className="ml-4 mb-4 text-[14pt] font-[600] font-archivo text-darker-sage  relative">
        <button
          className={`${
            showToc ? "-top-8" : "top-auto -left-20"
          } lg:hidden absolute`}
          onClick={() => setShowToc(!showToc)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            {!showToc ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            )}
          </svg>
        </button>
        {t("toc")}
      </li>
      {headings.map(({ value, depth, id }, index) => (
        <li key={index}>
          <Link
            className={`transition transition-all ease-in-out ${headerSizes[depth]} block hover:bg-light-green px-5 py-2 break-normal border-l-[6px] border-light-green cursor-pointer hover:border-darker-sage text-[12pt] font-[500] font-archio`}
            to={id}
            activeClass="text-darker-sage !border-darker-sage"
            spy={true}
            hashSpy={true}
            smooth={true}
            offset={-50}
            duration={200}
            href={`#${id}`}
          >
            {value}
          </Link>{" "}
        </li>
      ))}
    </ul>
  )
}

export default Toc
